import React from 'react'
import StepWizard, { StepWizardChildProps } from 'react-step-wizard'
import SSIBenefitsIntroduction from './SSIBenefitsIntroduction'

import { Box } from 'rebass'

import { WIZARD_STEPS_MAPPING } from 'containers/Apply/LongBeachWizard'
import { updatePercentageAndStep } from 'v2/components/XProgressBar/utils'

interface Props {
    personId?: any
    onNextStep: () => void
    updatePercentage: any
}

const SSIBenefitsWizardContainer: React.FC<Props> = (props: Props & StepWizardChildProps) => {
    const { percentage, wizardStep, childWizzardStep } = updatePercentageAndStep(
        WIZARD_STEPS_MAPPING.benefits,
        WIZARD_STEPS_MAPPING.benefits.ssi,
        WIZARD_STEPS_MAPPING
    )
    props.updatePercentage(percentage, wizardStep, childWizzardStep)

    return (
        <Box>
            <StepWizard
                transitions={{
                    enterRight: '',
                    enterLeft: '',
                    exitRight: '',
                    exitLeft: '',
                }}
                isLazyMount={true}
            >
                <SSIBenefitsIntroduction
                    onPrevious={props.previousStep}
                    personId={props.personId}
                    onNextStep={props.nextStep}
                />
            </StepWizard>
        </Box>
    )
}

export default SSIBenefitsWizardContainer
